/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import Box from '@material-ui/core/Box';
import { Button, Dropdown } from 'react-bootstrap';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import _, { set } from 'lodash';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';

// variable custom import
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  TableHeaderForDetails,
  TableHeaderForPQASDetails,
} from './gridComponents/tableHead';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  viewPortHeight_355,
  tabRadioInconsistencies,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import {
  redirectURLLink,
  isNumeric,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  handleErrorMessages,
  selectionList,
  singleInconsistency,
  headerInconsistency,
  getRosiGrid,
  getPqasGrid,
  getPreviousQuarterData,
  statusBit,
  dispatchPqasMainGrid,
  getViewDetailInconsistency,
  detailShowPqasData,
  detailShowRosiData,
  dispatchRosiMainGrid,
  dispatchTabValue,
} from '../store/actions';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
} from '../../../Display/NDC/store/action';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import * as AppConstants from '../../../../SharedModules/AppConstants';
import {
  dispatchActiveInvoiceNumber,
  getRosiAllocatePaymentDetail,
} from '../../../Tasks/AllocatePayments/store/Actions';
import { getAllocatePaymentScreenData } from '../../../Tasks/AllocatePayments/components/gridComponents/ROSIUtils';

function CMSInconsistenciesDetails() {
  const history = useHistory();
  const dispatch = useDispatch();
  const RedColor='#a81f00';
  const getSelectionList = useSelector(
    (state) => state.sharedState.CMSROSIPQASReducer.selection_list
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.errorMessagesInRedux
  );
  const headerInconsistentData = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.headerInconsistentData
  );
  const singleInconsistent = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.singleInconsistent
  );
  const rosiMainGrid = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.rosiMainGrid
  );
  const pqasMainGrid = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.pqasMainGrid
  );
  const quarterDataPqas = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.quarterDataPqas
  );
  const detailRosiData = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.detailRosiData
  );
  const detailPqasData = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.detailPqasData
  );
  const tabValueStore = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.tabValueStore
  );
  const activeInvoiceNumArray = useSelector(
    (state) => state?.sharedState?.AllocatePaymentReducer?.activeInvoiceNum
  );

  const AllocatePaymentReducer = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer
  );
  // variable declaration
  const gridRef = React.useRef();
  const [loading, setLoading] = React.useState(true);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [textBoxPaginate, setTextBoxPaginate] = React.useState();
  const [state, setState] = React.useState({
    rosiViewDetails: detailRosiData ? 'Y' : 'N',
    pqasViewDetails: detailPqasData ? 'Y' : 'N',
  });
  const [tabValue, setTabValue] = React.useState(tabValueStore || '');
  const [singleQuarter, setSingleQuarter] = React.useState({});
  const [allPqasQuarters, setAllPqasQuarters] = React.useState([]);
  const [checkKey, setCheckKey] = React.useState(true);
  const [otherKey, setOtherKey] = React.useState(true);
  const [paramsStore, setParamsStore] = React.useState();
  const [rosiParams, setRosiParams] = React.useState();
  const [commonPopup, setCommonPopup] = React.useState(false);
  const [warningAlert, setWarningAlert] = React.useState(false);
  const [warningMessage, setWaringMessage] = React.useState('');
  const [modalTitle, setModalTitle] = React.useState('');

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  // call ROSI Grid Data
  const getRosiGridData = (headerDetails) => {
    const payload = {
      invoiceNum: headerDetails?.invoiceNum,
      checkLogNum: headerDetails?.checkLogNum,
    };
    dispatch(getRosiGrid(payload));
  };
  // call PQAS Dropdown Data
  const getPreviousDropdown = (header) => {
    const payload = {
      checkLogNum: header?.checkLogNum,
      invoiceNum: header?.invoiceNum,
    };
    dispatch(getPreviousQuarterData(payload));
  };
  // call PQAS Grid Data
  const getPqasGridData = (qtr) => {
    const payload = {
      invoiceNumCID: singleInconsistent.invoiceNum,
      invoiceNum: singleInconsistent.invoiceNum,
      checkLogNum: singleInconsistent.checkLogNum,
      invoiceQtr: singleInconsistent.qtr,
      rosiPqasQtr: qtr,
    };
    dispatch(getPqasGrid(payload));
  };
  // handling disputeHeader details in paginated form
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(statusBit(0));

    if (headerInconsistentData && headerInconsistentData.status === '001') {
      if (headerInconsistentData?.response.length > 0) {
        const newAllHeader = (headerInconsistentData?.response).map(
          (item, index) => {
            item.indexPaginate = index + 1;
            return item;
          }
        );
        dispatch(headerInconsistency(newAllHeader));

        getRosiGridData(newAllHeader[0]);
        getPreviousDropdown(newAllHeader[0]);

        dispatch(singleInconsistency(newAllHeader[0]));
        setTextBoxPaginate(newAllHeader[0].indexPaginate);
      }
    }
  }, []);

  // handling tab refresh
  React.useEffect(() => {
    dispatch(dispatchTabValue(tabValue));
  }, [tabValue]);

  // handling highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.detailScreenErrors &&
      errorMessagesFromRedux?.detailScreenErrors.length > 0
    ) {
      tabHighLigther('/rosiInconsistenciesDetail', true);
    } else {
      tabHighLigther('/rosiInconsistenciesDetail', false);
    }
  }, [errorMessagesFromRedux]);

  // Handling refresh pagination
  React.useEffect(() => {
    if (singleInconsistent && singleInconsistent.indexPaginate) {
      setTextBoxPaginate(singleInconsistent.indexPaginate);
    }
  }, [singleInconsistent]);

  // handling PQAS one after the other
  React.useEffect(() => {
    if (quarterDataPqas && quarterDataPqas.length > 0) {
      const newObj = quarterDataPqas.map((item, index) => {
        item.paginate = index + 1;
        return item;
      });
      setAllPqasQuarters(newObj);
      setCheckKey(true);
      setSingleQuarter(
        newObj[parseInt(getSelectionList.qtrPaginate, [1, 1000]) - 1]
      );
      getPqasGridData(
        newObj[parseInt(getSelectionList.qtrPaginate, [1, 1000]) - 1].invRecQtr
      );
    } else {
      setLoading(false);
      setAllPqasQuarters([]);
      setSingleQuarter({});
      dispatch(dispatchPqasMainGrid([]));
    }
  }, [quarterDataPqas]);

  // handling PQAS data grid row selection
  React.useEffect(() => {
    if (checkKey && pqasMainGrid && pqasMainGrid.length > 0) {
      setLoading(false);
      setCheckKey(false);

      const newObj = pqasMainGrid?.map((item, index) => {
        if (parseInt(getSelectionList.qtrPaginate, [1, 1000]) - 1 === index) {
          item.value = true;
        } else {
          item.value = false;
        }
        return item;
      });
      dispatch(dispatchPqasMainGrid(newObj));
      paramsStore &&
        paramsStore.api.forEachNode(
          (node) => node.rowIndex === 0 && node.setSelected(true)
        );
    }
  }, [pqasMainGrid]);

  // handling ROSI main grid set selected row
  React.useEffect(() => {
    if (otherKey && rosiMainGrid && rosiMainGrid.length > 0) {
      setLoading(false);
      setOtherKey(false);

      const newObj = rosiMainGrid?.map((item, index) => {
        if (index === 0) {
          item.value = true;
        } else {
          item.value = false;
        }
        return item;
      });
      dispatch(dispatchRosiMainGrid(newObj));
      rosiParams &&
        rosiParams.api.forEachNode(
          (node) => node.rowIndex === 0 && node.setSelected(true)
        );
    }
  }, [rosiMainGrid]);

  // when both values are received
  React.useEffect(() => {
    if (rosiMainGrid?.length > 0 && pqasMainGrid?.length > 0) {
      setTabValue('one');
    } else if (rosiMainGrid?.length === 0 && pqasMainGrid?.length > 0) {
      setTabValue('two');
    } else if (rosiMainGrid?.length > 0 && pqasMainGrid?.length === 0) {
      setTabValue('one');
    }
  }, [rosiMainGrid && pqasMainGrid]);

  // handling by default row selection for PQAS
  const onGridReady = (params) => {
    setParamsStore(params);
    if (pqasMainGrid && pqasMainGrid?.length > 0) {
      params.api.forEachNode(
        (node) =>
          node.rowIndex ===
            pqasMainGrid.findIndex((x) => {
              return x.drugSeqNum === node.data.drugSeqNum && x.value;
            }) && node.setSelected(true)
      );
    }
  };

  // handling by default row selection for ROSI
  const onRosiGridReady = (params) => {
    setRosiParams(params);
    if (rosiMainGrid && rosiMainGrid?.length > 0) {
      params.api.forEachNode(
        (node) =>
          node.rowIndex ===
            rosiMainGrid.findIndex((x) => {
              return x.drugSeqNum === node.data.drugSeqNum && x.value;
            }) && node.setSelected(true)
      );
    }
  };

  // handling previous quarter pagination
  const moveQtrPaginate = (value) => {
    setLoading(true);
    dispatch(
      selectionList({
        ...getSelectionList,
        qtrPaginate: allPqasQuarters[value].paginate,
      })
    );
    setCheckKey(true);
    setSingleQuarter(allPqasQuarters[value]);
    getPqasGridData(allPqasQuarters[value].invRecQtr);
    dispatch(detailShowPqasData(null));
    setState({
      ...state,
      pqasViewDetails: 'N',
    });
  };

  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // handling pagination from header
  const paginateData = (indexNumber, flag) => {
    dispatch(dispatchRosiMainGrid([]));
    dispatch(
      handleErrorMessages({
        searchScreenErrors: [],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
    const localErr = errorMessagesFromRedux?.detailScreenErrors
      ? errorMessagesFromRedux?.detailScreenErrors
      : [];
    const findVal = localErr.filter((item) => item.errorType === 'validate');

    if (!flag) {
      if (findVal?.length === 0) {
        setLoading(true);
        dispatch(
          selectionList({
            ...getSelectionList,
            paginateIndex: indexNumber,
          })
        );
        setCheckKey(true);
        setOtherKey(true);
        getRosiGridData(headerInconsistentData[indexNumber]);
        getPreviousDropdown(headerInconsistentData[indexNumber]);
        dispatch(singleInconsistency(headerInconsistentData[indexNumber]));

        setTextBoxPaginate(headerInconsistentData[indexNumber]?.indexPaginate);
        dispatch(detailShowRosiData(null));
        dispatch(detailShowPqasData(null));
        setState({
          rosiViewDetails: 'N',
          pqasViewDetails: 'N',
        });
        dispatch(
          selectionList({
            ...getSelectionList,
            qtrPaginate: 1,
          })
        );
      }
    } else {
      setLoading(false);
      setTextBoxPaginate(indexNumber);
    }
  };

  // handing Pagination validation on Blur event
  const handlePaginateBlur = () => {
    const arr = errorMessagesFromRedux?.detailScreenErrors
      ? errorMessagesFromRedux?.detailScreenErrors
      : [];
    // eslint-disable-next-line no-unused-vars
    let isInputValue = false;

    const inputValue = isNumeric(textBoxPaginate);

    if ((inputValue && textBoxPaginate) > headerInconsistentData.length) {
      arr.push({
        field: 'input',
        errorType: 'inputIsGreter',
        message: constantMessageData.INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
      });
    } else {
      isInputValue = true;
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, { field: 'input', errorType: 'inputIsGreter' })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }
    }

    if (inputValue && isInputValue && textBoxPaginate !== '0') {
      setLoading(true);
      setCheckKey(true);
      setOtherKey(true);
      dispatch(
        selectionList({
          ...getSelectionList,
          paginateIndex: parseInt(textBoxPaginate, [1, 1000]) - 1,
        })
      );
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, { field: 'input', errorType: 'validate' })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }

      getRosiGridData(
        headerInconsistentData[parseInt(textBoxPaginate, [1, 1000]) - 1]
      );
      getPreviousDropdown(
        headerInconsistentData[parseInt(textBoxPaginate, [1, 1000]) - 1]
      );
      dispatch(
        singleInconsistency(
          headerInconsistentData[parseInt(textBoxPaginate, [1, 1000]) - 1]
        )
      );

      setTextBoxPaginate(textBoxPaginate);
      dispatch(detailShowRosiData(null));
      dispatch(detailShowPqasData(null));
      setState({
        rosiViewDetails: 'N',
        pqasViewDetails: 'N',
      });
      dispatch(
        selectionList({
          ...getSelectionList,
          qtrPaginate: 1,
        })
      );
    } else {
      if (inputValue && textBoxPaginate < headerInconsistentData.length) {
        arr.push({
          field: 'input',
          errorType: 'validate',
          message: constantMessageData.ERR_PAGINATE_VALUE,
        });

        dispatch(
          singleInconsistency({
            ...singleInconsistent,
            indexPaginate: textBoxPaginate,
          })
        );
      }
      if (inputValue === false) {
        arr.push({
          field: 'input',
          errorType: 'validate',
          message: constantMessageData.ERR_PAGINATE_VALUE,
        });
        dispatch(
          singleInconsistency({
            ...singleInconsistent,
            indexPaginate: textBoxPaginate,
          })
        );
      }
    }
    setLoading(false);
    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [...new Set(arr)],
      })
    );

    window.scrollTo(0, 0);
  };

  const callViewDetailService = (data, bit) => {
    const payload = {
      invoiceNum: data[0]?.invoiceNum,
      drugSeqNum: data[0]?.drugSeqNum,
      invRecQtr: bit === 0 ? data[0]?.invoiceQtr : singleQuarter?.invRecQtr,
      invRecSeqNum: data[0]?.invRecSeqNum,
    };
    dispatch(getViewDetailInconsistency(payload, bit));
  };
  // handling On change event on field level
  const handleOnChangeEvent = (e) => {
    let localErr = errorMessagesFromRedux?.detailScreenErrors
      ? errorMessagesFromRedux?.detailScreenErrors
      : [];
    localErr = localErr.filter((item) => item?.field !== 'search');

    setState({ ...state, [e.target.name]: e.target.value });

    if (e.target.name === 'rosiViewDetails') {
      if (e.target.value === 'Y') {
        const data = rosiMainGrid?.filter((item) => item.value === true);
        callViewDetailService(data, 0);
      } else {
        dispatch(detailShowRosiData(null));
      }
    } else if (e.target.name === 'pqasViewDetails') {
      if (e.target.value === 'Y') {
        const data = pqasMainGrid?.filter((item) => item.value === true);

        if (data.length === 0) {
          const newObj = pqasMainGrid?.map((item, index) => {
            if (index === 0) {
              item.value = true;
            } else {
              item.value = false;
            }
            return item;
          });
          dispatch(dispatchPqasMainGrid(newObj));
          paramsStore &&
            paramsStore.api.forEachNode(
              (node) => node.rowIndex === 0 && node.setSelected(true)
            );

          callViewDetailService(pqasMainGrid, 1);
        } else {
          callViewDetailService(data, 1);
        }
      } else {
        dispatch(detailShowPqasData(null));
      }
    }

    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [...new Set(localErr)],
      })
    );
  };

  // select row one by one in Rosi grid
  const onRosiRowSelect = (rowData) => {
    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [],
      })
    );
    const newObj = rosiMainGrid?.map((item) => {
      if (
        rowData?.filter((x) => {
          return x.drugSeqNum === item.drugSeqNum;
        }).length > 0
      ) {
        item.value = true;
      } else {
        item.value = false;
      }
      return item;
    });
    dispatch(dispatchRosiMainGrid(newObj));

    if (rowData?.length > 0 && state.rosiViewDetails === 'Y') {
      callViewDetailService(rowData, 0);
    }
  };

  // select row one by one in Rosi grid
  const onPqasRowSelect = (rowData) => {
    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [],
      })
    );
    const newObj = pqasMainGrid?.map((item) => {
      if (
        rowData?.filter((x) => {
          return x.drugSeqNum === item.drugSeqNum;
        }).length > 0
      ) {
        item.value = true;
      } else {
        item.value = false;
      }
      return item;
    });
    dispatch(dispatchPqasMainGrid(newObj));

    if (rowData?.length > 0 && state.pqasViewDetails === 'Y') {
      callViewDetailService(rowData, 1);
    }
  };
  // redirect Allocate payment ROSI/PQAS screen
  const redirectRPScreen = async () => {
    const newObj = activeInvoiceNumArray || [];
    newObj.push({
      index: newObj.length,
      invoiceNum: singleInconsistent?.invoiceNum,
      checkLogNum: singleInconsistent?.checkLogNum,
      active: true,
    });
    const resultData = await dispatch(
      getRosiAllocatePaymentDetail({
        invoiceNum: singleInconsistent?.invoiceNum,
        checkLogNum: singleInconsistent?.checkLogNum,
        checkPayeeCD: 'MD',
        checkAmt: 0,
        mfgId: singleInconsistent?.mfgId,
        planType: getSelectionList?.planTypeCd,
      })
    );
    const data = resultData?.headerAllocatePaymentData;
    const headerAllocatePaymentVO =
      resultData?.headerAllocatePaymentData?.headerAllocatePaymentVO;
    if (
      headerAllocatePaymentVO &&
      Object.keys(headerAllocatePaymentVO)?.length > 0
    ) {
      dispatch(dispatchActiveInvoiceNumber(newObj));
      getAllocatePaymentScreenData(
        data,
        dispatch,
        AllocatePaymentReducer,
        history,
        newObj
      );
    } else if (data?.forzenCase) {
      setWarningAlert(true);
      setModalTitle('Warning');
      setWaringMessage(constantMessageData.INVOICE_NUMBER_NOT_FROZEN);
    } else if (data?.noCheckPayeeForInvoice) {
      setWarningAlert(true);
      setModalTitle('Warning');
      setWaringMessage(constantMessageData.CHECK_PAYEE_CODE_INV_NUMBER_MSG);
    } else if (
      data?.headerAllocatePaymentVO == null &&
      data?.checkPayeeMessage
    ) {
      setWarningAlert(true);
      setWaringMessage(data?.checkPayeeMessage);
      setModalTitle('Warning');
    }
  };

  // Go to NDC details screen
  const goToNdcDetails = async (data) => {
    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [],
      })
    );
    const response = await getNDCDetails([
      { ndc: data.ndc, drugName: data.drugName },
    ]);
    if (response) {
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(setCurrentNDCDetailsIndex(1));
      dispatch(setCurrentNDCDetailsSelected(response[0]));
      dispatch(setNDCDetails([{ ndc: data.ndc, drugName: data.ndc }]));
      redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
    }
  };

  // custom frame component for actions and values on the tablegrid
  const detailsNDCframeworkComponents = {
    HyperLinkNameRender: (cellInfo) => {
      let name = '';
      if (cellInfo?.colDef?.headerName === 'NDC') {
        name = cellInfo.data.ndc;
      }

      return (
        <div>
          <a
            href="javascript:void()"
            onClick={() => goToNdcDetails(cellInfo.data)}
          >
            {name}
          </a>
        </div>
      );
    },
    FullNameRender: (cellInfo) => {
      let name = '';

      if (cellInfo?.colDef?.headerName === 'Drug Name') {
        name = cellInfo.data.drugName;
      }

      if (name && name.length > 20) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    adjustedUraCellRender: (cellInfo) => {
      let isNegativeVal = false;
      if (
        cellInfo?.data?.adjustedUnitRebateAmt &&
        cellInfo?.data?.adjustedUnitRebateAmt !== 0 &&
        cellInfo?.data?.adjustedUnitRebateAmt !== '0'
      ) {
        isNegativeVal = !(
          parseFloat(
            cellInfo?.data?.adjustedUnitRebateAmt?.toString().split('$')[1]
          ) >= 0
        );
      }

      return (
        <>
          {isNegativeVal ? (
            <div
              style={{ color: RedColor }}
            >{`(${cellInfo?.data?.adjustedUnitRebateAmt
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.adjustedUnitRebateAmt}`}</div>
          )}
        </>
      );
    },
    invoiceCorrectionAmtCellRender: (cellInfo) => {
      let isNegativeVal = false;
      if (
        cellInfo?.data?.invoiceCorrectionAmt &&
        cellInfo?.data?.invoiceCorrectionAmt !== 0
      ) {
        isNegativeVal = !(
          parseFloat(
            cellInfo?.data?.invoiceCorrectionAmt?.toString().split('$')[1]
          ) >= 0
        );
      }

      return (
        <>
          {isNegativeVal ? (
            <div
              style={{ color: RedColor }}
            >{`(${cellInfo?.data?.invoiceCorrectionAmt
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.invoiceCorrectionAmt}`}</div>
          )}
        </>
      );
    },
    withheldInvoiceAmtCellRender: (cellInfo) => {
      let isNegativeVal = false;
      if (
        cellInfo?.data?.withheldInvoiceAmt &&
        cellInfo?.data?.withheldInvoiceAmt !== 0
      ) {
        isNegativeVal = !(
          parseFloat(
            cellInfo?.data?.withheldInvoiceAmt?.toString().split('$')[1]
          ) >= 0
        );
      }

      return (
        <>
          {isNegativeVal ? (
            <div
              style={{ color: RedColor }}
            >{`(${cellInfo?.data?.withheldInvoiceAmt
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.withheldInvoiceAmt}`}</div>
          )}
        </>
      );
    },
    paidAmtCellRender: (cellInfo) => {
      let isNegativeVal = false;
      if (cellInfo?.data?.paidAmt && cellInfo?.data?.paidAmt !== 0) {
        isNegativeVal = !(
          parseFloat(cellInfo?.data?.paidAmt?.toString().split('$')[1]) >= 0
        );
      }

      return (
        <>
          {isNegativeVal ? (
            <div style={{ color: RedColor }}>{`(${cellInfo?.data?.paidAmt
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.paidAmt}`}</div>
          )}
        </>
      );
    },
    orgInvoiceAmtCellRender: (cellInfo) => {
      let isNegativeVal = false;
      if (
        cellInfo?.data?.orignalInvoiceAmt &&
        cellInfo?.data?.orignalInvoiceAmt !== 0
      ) {
        isNegativeVal = !(
          parseFloat(
            cellInfo?.data?.orignalInvoiceAmt?.toString().split('$')[1]
          ) >= 0
        );
      }

      return (
        <>
          {isNegativeVal ? (
            <div style={{ color: RedColor }}>{`(${cellInfo?.data?.orignalInvoiceAmt
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.orignalInvoiceAmt}`}</div>
          )}
        </>
      );
    },
    revisedInvoiceAmtCellRender: (cellInfo) => {
      let isNegativeVal = false;
      if (
        cellInfo?.data?.revisedInvoiceAmt &&
        cellInfo?.data?.revisedInvoiceAmt !== 0
      ) {
        isNegativeVal = !(
          parseFloat(
            cellInfo?.data?.revisedInvoiceAmt?.toString().split('$')[1]
          ) >= 0
        );
      }

      return (
        <>
          {isNegativeVal ? (
            <div style={{ color: RedColor }}>{`(${cellInfo?.data?.revisedInvoiceAmt
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.revisedInvoiceAmt}`}</div>
          )}
        </>
      );
    },
    priorPaidAmtCellRender: (cellInfo) => {
      let isNegativeVal = false;
      if (cellInfo?.data?.priorPaidAmt && cellInfo?.data?.priorPaidAmt !== 0) {
        isNegativeVal = !(
          parseFloat(cellInfo?.data?.priorPaidAmt?.toString().split('$')[1]) >=
          0
        );
      }

      return (
        <>
          {isNegativeVal ? (
            <div style={{ color: RedColor }}>{`(${cellInfo?.data?.priorPaidAmt
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.priorPaidAmt}`}</div>
          )}
        </>
      );
    },
    currentAmtCellRender: (cellInfo) => {
      let isNegativeVal = false;
      if (cellInfo?.data?.currAmtPaid && cellInfo?.data?.currAmtPaid !== 0) {
        isNegativeVal = !(
          parseFloat(cellInfo?.data?.currAmtPaid?.toString().split('$')[1]) >= 0
        );
      }

      return (
        <>
          {isNegativeVal ? (
            <div style={{ color: RedColor }}>{`(${cellInfo?.data?.currAmtPaid
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.currAmtPaid}`}</div>
          )}
        </>
      );
    },
    paidThisTransactionAmtCellRender: (cellInfo) => {
      let isNegativeVal = false;
      if (
        cellInfo?.data?.paidThisTransactionAmt &&
        cellInfo?.data?.paidThisTransactionAmt !== 0
      ) {
        isNegativeVal = !(
          parseFloat(
            cellInfo?.data?.paidThisTransactionAmt?.toString().split('$')[1]
          ) >= 0
        );
      }

      return (
        <>
          {isNegativeVal ? (
            <div
              style={{ color: RedColor }}
            >{`(${cellInfo?.data?.paidThisTransactionAmt
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.paidThisTransactionAmt}`}</div>
          )}
        </>
      );
    },
    adjustedUnitsCellRender: (cellInfo) => {
      let isNegativeVal = false;

      if (
        cellInfo?.data?.adjustedUnits &&
        cellInfo?.data?.adjustedUnits !== 0 &&
        cellInfo?.data?.adjustedUnits !== '0'
      ) {
        isNegativeVal = !(
          parseFloat(cellInfo?.data?.adjustedUnits?.toString()) >= 0
        );
        // cellInfo.data.adjustedUnits =
        //   cellInfo?.data.adjustedUnits % 1 !== 0
        //     ? cellInfo?.data?.adjustedUnits.toFixed(3)
        //     : cellInfo?.data?.adjustedUnits.toFixed(1);
      }

      return (
        <>
          {isNegativeVal ? (
            <div style={{ color: RedColor }}>
              {`(${cellInfo?.data?.adjustedUnits

                ?.toString()
                ?.replace('-', '')
                .trim()})`}
            </div>
          ) : (
            <div>{`${cellInfo?.data?.adjustedUnits}`}</div>
          )}
        </>
      );
    },
    UnitRebateAmtCellRender: (cellInfo) => {
      const value = parseFloat(cellInfo?.value);
      if (cellInfo?.data?.isBottomRow) {
        const pinnedValue = parseFloat(cellInfo?.value);
        if (pinnedValue < 0) {
          return (
            <b>
              <span style={{ color: '#eb0000' }}>
                (
                {` ${Math.abs(parseFloat(pinnedValue)).toLocaleString('en-US', {
                  minimumFractionDigits: 6,
                  maximumFractionDigits: 6,
                })}`}
                )
              </span>
            </b>
          );
        }
        if (pinnedValue) {
          return (
            <b>
              {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
                minimumFractionDigits: 6,
                maximumFractionDigits: 6,
              })}`}
            </b>
          );
        }
        return <b> 0.000000</b>;
      }
      if (value < 0) {
        return (
          <span style={{ color: '#eb0000' }}>
            (
            {Math.abs(parseFloat(value)).toLocaleString('en-US', {
              minimumFractionDigits: 6,
              maximumFractionDigits: 6,
            })}
            )
          </span>
        );
      }
      if (value) {
        return ` ${parseFloat(value)?.toLocaleString('en-US', {
          minimumFractionDigits: 6,
          maximumFractionDigits: 6,
        })}`;
      }
      return ' 0.000000';
    },
    TotalUnitsCellRender: (cellInfo) => {
      const value = parseFloat(cellInfo?.value);
      if (cellInfo?.data?.isBottomRow) {
        const pinnedValue = parseFloat(cellInfo?.value);
        if (pinnedValue < 0) {
          return (
            <b>
              <span style={{ color: '#eb0000' }}>
                (
                {` ${Math.abs(parseFloat(pinnedValue)).toLocaleString('en-US', {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3,
                })}`}
                )
              </span>
            </b>
          );
        }
        if (pinnedValue) {
          return (
            <b>
              {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
              })}`}
            </b>
          );
        }
        return <b> 0.000</b>;
      }
      if (value < 0) {
        return (
          <span style={{ color: '#eb0000' }}>
            (
            {Math.abs(parseFloat(value)).toLocaleString('en-US', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3,
            })}
            )
          </span>
        );
      }
      if (value) {
        return ` ${parseFloat(value)?.toLocaleString('en-US', {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        })}`;
      }
      return ' 0.000';
    },
  };
  return (
    <>
      <div className="tabs-container" data-testid="inconsistency-details-id">
        <CustomSeparator
          parent1="Research"
          parent2="Display ROSI/PQAS Inconsistencies Rpt"
        />

        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              errorMessagesFromRedux?.detailScreenErrors?.length > 0
                ? _.map(
                    errorMessagesFromRedux?.detailScreenErrors,
                    (l) => l.message
                  )
                : []
            ),
          ]}
        />

        <Spinner load={loading} />

        <>
          {!fullScreenView && (
            <Box className="alone-pagination mb-2 frr-additional-right">
              <Box>
                <Button
                  aria-label="Previous"
                  title="Previous"
                  className="btns rotate-left"
                  data-testid="uc-paginate-arrow-left"
                  disabled={
                    !(singleInconsistent?.indexPaginate > 1) ||
                    !isNumeric(singleInconsistent?.indexPaginate) ||
                    headerInconsistentData?.length <
                      singleInconsistent?.indexPaginate
                  }
                  onClick={() => {
                    if (singleInconsistent?.indexPaginate > 1) {
                      paginateData(
                        parseInt(textBoxPaginate, [0, 1000]) - 2,
                        false
                      );
                    }
                  }}
                >
                  <SVGComponent iconName="Icon-arrow" />
                  <span className="hide-elm">Previous</span>
                </Button>
              </Box>
              <Box>
                <label className="m-0" htmlFor="paginate-count">
                  <TextField
                    id="paginate-count"
                    data-testid="uc-input-paginate"
                    variant="outlined"
                    className="searchInput input-count"
                    value={textBoxPaginate}
                    onChange={(e) => paginateData(e.target.value, true)}
                    onBlur={() => {
                      handlePaginateBlur();
                    }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 9 || e.key === 'Enter') {
                        e.preventDefault();
                        e.target.blur();
                        handlePaginateBlur();
                      }
                    }}
                    size="small"
                  />
                </label>
              </Box>
              <Box className="btns"> of {headerInconsistentData?.length}</Box>
              <Box>
                <Button
                  aria-label="Next"
                  title="Next"
                  className="btns rotate-right ml-0"
                  data-testid="uc-paginate-arrow-right"
                  disabled={
                    singleInconsistent?.indexPaginate >
                      headerInconsistentData?.length - 1 ||
                    !isNumeric(singleInconsistent?.indexPaginate)
                  }
                  onClick={() => {
                    if (
                      singleInconsistent?.indexPaginate !==
                      headerInconsistentData?.length
                    ) {
                      paginateData(parseInt(textBoxPaginate, [0, 1000]), false);
                    }
                  }}
                >
                  <SVGComponent iconName="Icon-arrow" />
                  <span className="hide-elm">Next</span>
                </Button>
              </Box>
            </Box>
          )}

          {!fullScreenView && (
            <Dropdown className="icon-dropdown-container frr-export-icon">
              <Dropdown.Toggle className="icon-dropdown" aria-label="Export">
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="action-tooltip">Actions</Tooltip>}
                >
                  <SVGComponent iconName="Icon-export" />
                </OverlayTrigger>
              </Dropdown.Toggle>
              <Dropdown.Menu className="export_dropdown h-auto">
                <Dropdown.Item
                  data-testid="redirection-to-rp"
                  onClick={() => {
                    redirectRPScreen();
                  }}
                >
                  Go To ROSI/PQAS
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}

          {!fullScreenView && (
            <Box className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="IQ_Quarter"
                      label="Invoice Quarter"
                      fullWidth
                      disabled
                      placeholder=""
                      inputProps={{ id: 'IQ_Quarter' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={singleInconsistent?.qtr}
                    />
                  </div>

                  <div className="mui-custom-form input-md">
                    <TextField
                      id="invoice_number"
                      label="Invoice Number"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={singleInconsistent?.invoiceNum}
                    />
                  </div>

                  <div className="mui-custom-form input-md">
                    <TextField
                      id="manuf_id"
                      label="Manufacturer ID"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={singleInconsistent?.mfgId}
                    />
                  </div>
                </div>
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="com-tooltip">
                          {singleInconsistent?.mfgName}
                        </Tooltip>
                      }
                    >
                      {singleInconsistent?.mfgName?.length >= 30 ? (
                        <TextField
                          id="manufName"
                          label="Manufacturer Name"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={`${singleInconsistent?.mfgName?.substring(
                            0,
                            30
                          )} ...`}
                        />
                      ) : (
                        <TextField
                          id="manufName"
                          label="Manufacturer Name"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={singleInconsistent?.mfgName}
                        />
                      )}
                    </OverlayTrigger>
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="contact"
                      label="Check Log Number"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={singleInconsistent?.checkLogNum}
                    />
                  </div>

                  <div className="mui-custom-form input-md">
                    <TextField
                      id="rebate_program"
                      label="Rebate Program"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ id: 'rebate_program' }}
                      value={singleInconsistent?.shortDescr}
                    />
                  </div>
                </div>
              </div>
            </Box>
          )}

          {!fullScreenView && (
            <div className="tabs-wrapper mb-4">
              <AppBar
                position="static"
                sx={{ width: '100%' }}
                style={{ borderBottom: '1px solid #c9c8c5' }}
              >
                <Tabs
                  data-testid="change-tab-value"
                  value={tabValue}
                  onChange={(ev, val) => {
                    setTabValue(val);
                  }}
                >
                  <Tab
                    style={{ textTransform: 'capitalize' }}
                    value="one"
                    label="ROSI"
                    disabled={rosiMainGrid?.length === 0}
                    tabIndex={0}
                  />

                  <Tab
                    style={{ textTransform: 'capitalize' }}
                    value="two"
                    label="PQAS"
                    disabled={pqasMainGrid?.length === 0}
                    tabIndex={0}
                  />
                </Tabs>
              </AppBar>
            </div>
          )}

          <div className="clearfix" />
          {tabValue === 'one' && (
            <>
              {!fullScreenView && (
                <div className="row">
                  <div className="col-5 frr-rpinconsistencies-radio">
                    <fieldset
                      data-testid="radio-box-component"
                      className="radioBtnGroup custom-fieldset h-100 border-0"
                    >
                      <legend className="same-font-family">
                        {tabRadioInconsistencies}{' '}
                      </legend>
                      <div className="form-wrapper db ml-4">
                        <div className="sub-radio no-margin">
                          <FormControl>
                            <RadioGroup
                              data-testid="rosi-group-control"
                              row
                              name="rosiViewDetails"
                              defaultValue={state && state.rosiViewDetails}
                              value={state && state.rosiViewDetails}
                              onChange={handleOnChangeEvent}
                            >
                              <FormControlLabel
                                value="Y"
                                control={<Radio />}
                                label="Yes"
                                data-testid="Yes"
                              />
                              <FormControlLabel
                                value="N"
                                control={<Radio />}
                                label="No"
                                data-testid="No"
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              )}
              <div
                id="testGrid"
                className="panel-body FRR-custom-table tbl-manufacturer-inner"
              >
                <TableGrid
                  ref={gridRef}
                  data-testid="inconsistency-rosi-detail"
                  rowSelection="single"
                  gridCall={onRosiGridReady}
                  rowMultiSelectWithClick={false}
                  fullScreenView={fullScreenView}
                  handleFullScreenViewClick={handleFullScreenView}
                  gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
                  isScrollOn
                  rowData={
                    rosiMainGrid && rosiMainGrid.length > 0 ? rosiMainGrid : []
                  }
                  onSelect={(e) => onRosiRowSelect(e.api?.getSelectedRows())}
                  columnDefs={TableHeaderForDetails}
                  exportFile
                  animateRows
                  sideBar={false}
                  fileName="Inconsistency-Detail"
                  singleClickEdit
                  navigateToNextCell={navigateToNextCell}
                  tabToNextCell={tabToNextCell}
                  enterMovesDown
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                  frameworkComponents={detailsNDCframeworkComponents}
                />
              </div>
              {detailRosiData && (
                <div>
                  <p>
                    <b>Inconsistency Found :</b>
                  </p>
                  <p>
                    <b>
                      {detailRosiData?.longDesc} [{detailRosiData?.codeValue}]
                    </b>
                  </p>
                </div>
              )}
            </>
          )}
          {tabValue === 'two' && (
            <>
              {!fullScreenView && (
                <div className="row">
                  <div className="col-5 frr-rpinconsistencies-radio">
                    <fieldset
                      data-testid="radio-box-component"
                      className="radioBtnGroup custom-fieldset h-100 border-0"
                    >
                      <legend className="same-font-family">
                        {tabRadioInconsistencies}{' '}
                      </legend>
                      <div className="form-wrapper db ml-4">
                        <div className="sub-radio no-margin">
                          <FormControl>
                            <RadioGroup
                              data-testid="pqas-group-control"
                              row
                              name="pqasViewDetails"
                              defaultValue={state && state.pqasViewDetails}
                              value={state && state.pqasViewDetails}
                              onChange={handleOnChangeEvent}
                            >
                              <FormControlLabel
                                value="Y"
                                control={<Radio />}
                                label="Yes"
                                data-testid="Yes"
                              />
                              <FormControlLabel
                                value="N"
                                control={<Radio />}
                                label="No"
                                data-testid="No"
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className="col-5 col-md-5 col-sm-7 frr-left-right-scroller mt-md-2 ml-md-auto">
                    <Box className="alone-pagination mb-2 pt-4">
                      <Box>
                        <Button
                          aria-label="Previous"
                          title="Previous"
                          className="btns rotate-left"
                          data-testid="previous-arrow-left"
                          // disabled={
                          //   !(singleQuarter?.paginate > 1) ||
                          //   !isNumeric(singleQuarter?.paginate) ||
                          //   allPqasQuarters?.length < singleQuarter?.paginate
                          // }
                          onClick={() => {
                            if (
                              singleQuarter.paginate >
                              allPqasQuarters.length - 1
                            ) {
                              setCommonPopup(true);
                            } else if (
                              singleQuarter.paginate !== allPqasQuarters?.length
                            ) {
                              moveQtrPaginate(
                                parseInt(singleQuarter.paginate, [0, 1000])
                              );
                            }
                          }}
                        >
                          <SVGComponent iconName="Icon-arrow" />
                          <span className="hide-elm">Previous</span>
                        </Button>
                      </Box>
                      <Box>
                        <TextField
                          label="Previous Quarter Being Processed"
                          id="Previous-Quarter"
                          variant="outlined"
                          className="searchInput text-scroller"
                          InputLabelProps={{
                            shrink: false,
                          }}
                          value={singleQuarter?.invRecQtr}
                          disabled
                          size="small"
                        />
                      </Box>

                      <Box>
                        <Button
                          aria-label="Next"
                          title="Next"
                          className="btns rotate-right ml-0"
                          data-testid="previous-arrow-right"
                          // disabled={
                          //   singleQuarter.paginate > allPqasQuarters.length - 1
                          // }
                          onClick={() => {
                            if (
                              !(singleQuarter?.paginate > 1) ||
                              !isNumeric(singleQuarter?.paginate) ||
                              allPqasQuarters?.length < singleQuarter?.paginate
                            ) {
                              setCommonPopup(true);
                            } else if (allPqasQuarters.length > 1) {
                              moveQtrPaginate(
                                parseInt(singleQuarter.paginate, [0, 1000]) - 2
                              );
                            }
                          }}
                        >
                          <SVGComponent iconName="Icon-arrow" />
                          <span className="hide-elm">Next</span>
                        </Button>
                      </Box>
                    </Box>
                  </div>
                </div>
              )}
              <CommonModal
                open={commonPopup}
                className="dialog-420"
                viewAction
                viewHeader
                onOk={() => setCommonPopup(false)}
                okTitle="Ok"
                onClose={() => setCommonPopup(false)}
                modalTitle={AppConstants.COMMON_INCONSISTENCY_RPT}
                childrenComponent={
                  AppConstants.CHILDREN_COMMON_INCONSISTENCY_RPT
                }
              />
              <div
                id="testGrid"
                className="panel-body FRR-custom-table tbl-manufacturer-inner"
              >
                <TableGrid
                  ref={gridRef}
                  data-testid="inconsistency-pqas-detail"
                  rowSelection="single"
                  gridCall={onGridReady}
                  rowMultiSelectWithClick={false}
                  fullScreenView={fullScreenView}
                  handleFullScreenViewClick={handleFullScreenView}
                  gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
                  isScrollOn
                  rowData={
                    pqasMainGrid && pqasMainGrid.length > 0 ? pqasMainGrid : []
                  }
                  onSelect={(e) => onPqasRowSelect(e.api?.getSelectedRows())}
                  columnDefs={TableHeaderForPQASDetails}
                  exportFile
                  animateRows
                  sideBar={false}
                  fileName="Inconsistency-Detail"
                  singleClickEdit
                  navigateToNextCell={navigateToNextCell}
                  tabToNextCell={tabToNextCell}
                  enterMovesDown
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                  frameworkComponents={detailsNDCframeworkComponents}
                />
              </div>
              {detailPqasData && (
                <div>
                  <p>
                    <b>Inconsistency Found :</b>
                  </p>
                  <p>
                    <b>
                      {detailPqasData?.longDesc} [{detailPqasData?.codeValue}]
                    </b>
                  </p>
                </div>
              )}
            </>
          )}
        </>
      </div>
      <CommonModal
        className="dialog-420"
        data-testid="commonModal1"
        open={warningAlert}
        viewAction
        viewHeader
        onOk={() => {
          setWarningAlert(false);
        }}
        onClose={() => {
          setWarningAlert(false);
        }}
        okTitle="Ok"
        modalTitle={modalTitle}
        childrenComponent={<div className="p-3">{warningMessage}</div>}
      />
    </>
  );
}
export default withRouter(CMSInconsistenciesDetails);
